import React, { useState, useEffect } from "react";
import { useFirestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import { useSelector, connect } from "react-redux";
import LoadingIndicator from "../../../components/common/LoadingIndicator";
import { Link } from "react-router-dom";
import {
  RECEPTIONIST_ORDERS_PATH,
  USER_ORDERS_PATH,
} from "../../../constants/paths";

import OrderPreview from "../../../components/orders/OrderPreview";

import Sound from "react-sound";

function ReceptionGeneralPage() {
  const [playingSound, setPlayingSound] = useState(Sound.status.STOPPED);
  const [firstLoad, setFirstLoad] = useState(false);
  const [currentLength, setCurrentLength] = useState(0);

  // const uid = useSelector(({ firebase }) => firebase.auth.uid);

  useFirestoreConnect([
    {
      collection: "orders",
      limit: 5,
      orderBy: [["dateCreated", "desc"]],
      storeAs: "recent-orders",
    },
    // {
    //   collection: "restaurants",
    //   doc: restaurantId || "nothing",
    //   subcollections: [
    //     {
    //       collection: "orders",
    //       limit: 5,
    //       orderBy: [["dateCreated", "desc"]],
    //     },
    //   ],
    //   storeAs: `recent-orders`,
    // },
  ]);

  const profile = useSelector(({ firebase }) => firebase.profile);

  const recentOrders = useSelector(
    ({ firestore }) => firestore.ordered["recent-orders"]
  );

  useEffect(() => {
    if (isLoaded(recentOrders) && !isEmpty(recentOrders)) {
      if (!firstLoad) {
        setCurrentLength(recentOrders.length);
        return setFirstLoad(true);
      } else if (currentLength !== recentOrders.length) {
        setCurrentLength(recentOrders.length);
        return setPlayingSound(Sound.status.PLAYING);
      }
    }
  }, [recentOrders]);

  if (!isLoaded(profile) || !isLoaded(recentOrders))
    return <LoadingIndicator />;

  const handleSongFinishedPlaying = () => {
    setPlayingSound(Sound.status.STOPPED);
  };

  return (
    <div className="px-16 py-8 text-gray-900">
      <Sound
        url="https://firebasestorage.googleapis.com/v0/b/supercerca-inowu.appspot.com/o/iphone_5s_alarm.mp3?alt=media&token=d7c74dc2-db7f-44ef-af01-d90ce4af1348"
        playStatus={playingSound}
        playFromPosition={0}
        onFinishedPlaying={handleSongFinishedPlaying}
      />
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b flex justify-between">
          Órdenes recientes
        </p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          {isLoaded(recentOrders) &&
            recentOrders.map((order) => {
              return (
                <OrderPreview
                  {...order}
                  profile={profile}
                  key={order.id}
                ></OrderPreview>
              );
            })}
        </div>
        <div
          to={RECEPTIONIST_ORDERS_PATH}
          className="flex justify-end px-6 py-3 border-t border-gray-300"
        >
          <Link
            to={RECEPTIONIST_ORDERS_PATH}
            className="text-sm text-gray-700 font-bold inline-block"
          >
            Todas las órdenes
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ReceptionGeneralPage;
